import { plusiconwhite, serachicongrey } from "./threadsvg";

const STATUS_TABS = ["Open", "Closed"];

const crossIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const ThreadHeader = ({
  thread,
  filteredThreads,
  onNewThread,
  loading,
  search,
  setSearch,
  activeTab,
  setActiveTab,
  statusCounts = {},
  datePicker,
  filterIcon,
  isDefaultRange,
  startDate,
  endDate,
  onClearDate,
  onClearStatus,
  appliedCategories = [],
  onClearCategory,
  onClearAllCategories,
}) => {
  const hasDateFilter = !isDefaultRange;
  const hasStatusFilter = !!activeTab;
  const hasCategoryFilter = appliedCategories.length > 0;

  return (
    <div className="flex flex-col gap-3">
      {/* Row 1: Date picker + Search bar + Filter icon */}
      <div className="flex items-center gap-3">
        
        <div className="flex items-center flex-1 bg-[#F9FAFB] border border-[#E5E7EB] rounded-full px-4 py-2.5">
          <span className="mr-2 flex-shrink-0">{serachicongrey}</span>
          <input
            type="text"
            placeholder="Search threads..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full bg-transparent outline-none text-sm text-gray-600 placeholder-gray-400"
          />
        </div>
        {datePicker}
        {filterIcon}
      </div>

      {/* Row 2: Status tabs + Filter pills + New Thread button */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {/* Status tabs */}
          <div className="flex items-center gap-1">
            {STATUS_TABS.map((status) => {
              const isActive =
                activeTab && activeTab.toLowerCase() === status.toLowerCase();
              return (
                <button
                  key={status}
                  onClick={() => setActiveTab(status)}
                  className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium transition-all border-b-2 ${
                    isActive
                      ? "text-[#E17954] border-[#E17954]"
                      : "text-gray-500 border-transparent hover:text-gray-700"
                  }`}
                >
                  {status}
                  <span className="min-w-[20px] h-5 flex items-center justify-center rounded-full text-[11px] font-semibold px-1.5 bg-[#E17954] text-white">
                    {statusCounts[status] || 0}
                  </span>
                </button>
              );
            })}
          </div>

          {/* Filter pills */}
          {(hasDateFilter || hasStatusFilter || hasCategoryFilter) && (
            <div className="flex items-center gap-2 ml-2 flex-wrap">
              {hasDateFilter && (
                <span className="flex items-center gap-1.5 bg-[#FFF3EF] text-[#E17954] text-xs font-medium px-3 py-1.5 rounded-full border border-[#F5CFC0]">
                  {startDate?.isSame(endDate, "day")
                    ? startDate?.format("MM.DD.YYYY")
                    : `${startDate?.format("MM.DD")} - ${endDate?.format("MM.DD.YYYY")}`}
                  <button
                    onClick={onClearDate}
                    className="hover:text-red-600 transition-colors"
                  >
                    {crossIcon}
                  </button>
                </span>
              )}
              {hasStatusFilter && (
                <span className="flex items-center gap-1.5 bg-[#FFF3EF] text-[#E17954] text-xs font-medium px-3 py-1.5 rounded-full border border-[#F5CFC0]">
                  {activeTab}
                  <button
                    onClick={onClearStatus}
                    className="hover:text-red-600 transition-colors"
                  >
                    {crossIcon}
                  </button>
                </span>
              )}
              {appliedCategories.map((cat) => (
                <span
                  key={cat}
                  className="flex items-center gap-1.5 bg-[#EEF2FF] text-[#4F46E5] text-xs font-medium px-3 py-1.5 rounded-full border border-[#C7D2FE]"
                >
                  {cat}
                  <button
                    onClick={() => onClearCategory(cat)}
                    className="hover:text-red-600 transition-colors"
                  >
                    {crossIcon}
                  </button>
                </span>
              ))}
            </div>
          )}
        </div>

        {/* New Thread Button */}
        <button
          onClick={onNewThread}
          className="flex items-center gap-2 bg-[#E17954] text-white text-sm font-medium px-5 py-2.5 rounded-full shadow-sm hover:opacity-90"
        >
          {plusiconwhite}
          New Thread
        </button>
      </div>

      {filteredThreads?.length === 0 && !loading ? (
        <div className="flex flex-1 justify-center items-center text-gray-400 text-sm py-4">
          No threads found
        </div>
      ) : null}
    </div>
  );
};

export default ThreadHeader;
